"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1589],{

/***/ 11589:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SectionCaseStudyCards": function() { return /* binding */ SectionCaseStudyCards; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79570);
/* harmony import */ var _portfolio_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55022);
/* harmony import */ var _portfolio_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75762);



const StyledSectionWrapper = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)(_portfolio_components__WEBPACK_IMPORTED_MODULE_2__/* .SectionWrapper */ .Uq, {
    color: "$white",
    marginBottom: "$0"
});
const Content = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    margin: "0 auto",
    containerSpace: "medium",
    display: "grid",
    gap: "30px"
});
const Title = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("h2", {
    projectFont: "heading07"
});
const CardsList = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("ul", {
    listStyleType: "none",
    display: "grid",
    gridTemplateColumns: "repeat(1, 1fr)",
    gridTemplateRows: "repeat(3, 1fr)",
    gap: "30px",
    "@md": {
        gridTemplateColumns: "repeat(3, 1fr)",
        gridTemplateRows: "repeat(1, 1fr)"
    }
});
const CaseStudyTitle = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("h3", {
    color: "$white"
});
const CaseStudyDescription = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("span", {
    color: "$white_07"
});
const CardsListItem = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("li", {
    display: "grid",
    position: "relative",
    gridTemplateRows: "auto auto",
    "@lg": {
        gridTemplateRows: "1fr 1fr"
    }
});
const MediaWrap = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    gridRow: 1,
    gridColumn: 1,
    overflow: "hidden",
    borderRadius: "$r3",
    "& video + span": {
        clipPath: "inset(1px round 24px)"
    },
    "@lg": {
        gridColumn: 1,
        gridRow: "1 / 3"
    }
});
const ContentWrap = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)(_portfolio_components__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
    projectFont: "heading08",
    display: "grid",
    pointerEvents: "none",
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    padding: "$24",
    zIndex: "$content",
    alignContent: "flex-end",
    justifyContent: "space-between",
    background: "linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.3))",
    borderRadius: "$r3"
});
const LinkWrap = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)(_portfolio_components__WEBPACK_IMPORTED_MODULE_2__/* .Link */ .rU, {
    gridColumn: 1,
    gridRow: "1 / -1",
    zIndex: "$content",
    "&:focus-visible": {
        outline: "$focusBlue solid 5px;",
        outlineOffset: "-5px"
    }
});
const SectionCaseStudyCards = (param)=>{
    let { title , cards  } = param;
    if (!(cards === null || cards === void 0 ? void 0 : cards.length)) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledSectionWrapper, {
        type: "NO_MARGIN",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Content, {
            children: [
                title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Title, {
                    children: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CardsList, {
                    children: cards.map((param)=>{
                        let { _key , media , caseStudyReference  } = param;
                        return (media === null || media === void 0 ? void 0 : media.mediaPayload) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(CardsListItem, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MediaWrap, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_2__/* .Media */ .pU, {
                                        ...media,
                                        layout: "responsive",
                                        controlsPosition: "top-right",
                                        hardcropRatio: "portrait3",
                                        loop: true
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ContentWrap, {
                                    children: (caseStudyReference === null || caseStudyReference === void 0 ? void 0 : caseStudyReference.name) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(CaseStudyTitle, {
                                        as: title ? "h3" : "h2",
                                        children: [
                                            caseStudyReference === null || caseStudyReference === void 0 ? void 0 : caseStudyReference.name,
                                            (caseStudyReference === null || caseStudyReference === void 0 ? void 0 : caseStudyReference.shortDescription) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(CaseStudyDescription, {
                                                children: [
                                                    " ",
                                                    caseStudyReference === null || caseStudyReference === void 0 ? void 0 : caseStudyReference.shortDescription
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                (caseStudyReference === null || caseStudyReference === void 0 ? void 0 : caseStudyReference.path) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LinkWrap, {
                                    href: caseStudyReference === null || caseStudyReference === void 0 ? void 0 : caseStudyReference.path,
                                    appearance: "grid",
                                    label: "Case Study - ".concat(caseStudyReference === null || caseStudyReference === void 0 ? void 0 : caseStudyReference.name)
                                })
                            ]
                        }, _key) : null;
                    })
                })
            ]
        })
    });
};


/***/ })

}]);